import { GO_TO_APPLIANCE_STEP } from '#action/types';

export const goToApplianceStep = step => dispatch => {
  dispatch({ type: GO_TO_APPLIANCE_STEP, payload: step });
};
